import {
    createApp
} from 'vue'

import App from './App.vue'
import router from './router'
import store from './store'

import i2kFunctions from "i2kjslibrary"

import Functions from "@/utils/functions.js";

import Load from "./LOAD.js"

import "./assets/style.css"

import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import ToastPlugin from "@/components/toast/toast.js"

const vuetify = createVuetify({
    components,
    directives,
    icons: {
        defaultSet: 'mdi',
        aliases,
        sets: {
            mdi,
        },
    },

    theme: {
        defaultTheme: 'light',
        themes: {
            light: {
                colors: {
                    primary: '#1E3A5F',
                    secondary: '#F59E0B',
                    background: '#F3F4F6',
                    surface: '#FFFFFF',
                    error: '#DC2626',
                    success: '#16A34A'
                }
            }
        }
    }
})

const app = createApp(App)
    .use(store)
    .use(router)
    .use(vuetify)
    .provide('$load', Load)
    .provide('$i2kFunctions', i2kFunctions)
    .provide('$functions', Functions)

app.use(ToastPlugin, { location: "top", timeOut: 4000 })
app.mount('#app');